import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { useFavorites } from '@/contexts/FavoritesContext';
import { FavoriteListModal } from './FavoriteListModal';

export function FavoriteListPicker() {
  const {
    pickerState,
    closePickerAndReset,
    confirmPickerSelection,
    lists,
    getProductFavoriteLists,
    openCreateListFromPicker,
    setOpenCreateListFromPicker,
    handleNewListCreated,
  } = useFavorites();

  if (!pickerState) return null;

  const title = pickerState.mode === 'add' ? 'Add to Favorite List' : 'Remove from Favorite List';
  const entries = pickerState.mode === 'remove' ? getProductFavoriteLists(pickerState.productId) : [];

  return (
    <>
      <Dialog open={!!pickerState && !openCreateListFromPicker} onOpenChange={(v) => { if (!v) closePickerAndReset(); }}>
        <DialogContent className="sm:max-w-sm">
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
          </DialogHeader>
          <div className="space-y-2 py-2">
            {lists.map((list) => {
              if (pickerState.mode === 'remove' && !entries.some(e => e.listId === list.id)) {
                return null;
              }
              return (
                <Button
                  key={list.id}
                  variant="outline"
                  className="w-full justify-start text-left"
                  onClick={() => confirmPickerSelection(list.id)}
                >
                  {list.name}
                  {list.isDefault && (
                    <span className="ml-auto text-xs text-muted-foreground">Default</span>
                  )}
                </Button>
              );
            })}
            {pickerState.mode === 'add' && (
              <Button
                variant="ghost"
                className="w-full justify-start text-left text-primary"
                onClick={() => setOpenCreateListFromPicker(true)}
              >
                <Plus className="h-4 w-4 mr-2" />
                New List
              </Button>
            )}
          </div>
        </DialogContent>
      </Dialog>

      <FavoriteListModal
        open={openCreateListFromPicker}
        onOpenChange={(v) => { if (!v) setOpenCreateListFromPicker(false); }}
        onSaved={handleNewListCreated}
        hasExistingLists={lists.length > 0}
        totalLists={lists.length}
      />
    </>
  );
}
